import CICard from './CICard';

export default CICard;
